import { useContext, useState } from 'react'
import { DineInContext } from 'contexts/DineInProvider'
import { dineInClient } from 'variables/services'
import { useListFpMemberCouponsLazyQuery } from 'graphQL/dinein/generate/operations'
import { convertListFPMemberCouponsToCoupons } from 'helpers/coupon'
import { Coupon } from 'types/coupon'

interface UseShareCouponProps {
  orderID: number
  userIDs: number[]
  currentMembershipId: number
}

const useFpmemberCoupons = ({ orderID, userIDs, currentMembershipId }: UseShareCouponProps) => {
  const { allowedSharingCoupon } = useContext(DineInContext)
  const [coupons, setCoupons] = useState<Coupon[]>([])

  const [listFpMemberCouponsLazyQuery, { loading: loadingListFpMemberCoupons }] = useListFpMemberCouponsLazyQuery({
    client: dineInClient,
    variables: { orderID, filter: { userIDs } },
    notifyOnNetworkStatusChange: true,
    onCompleted: ({ listFPMemberCoupons }) => {
      const fpCoupons = convertListFPMemberCouponsToCoupons({
        listFPMemberCoupons,
        currentMembershipId,
        allowedSharingCoupon,
      })
      setCoupons(fpCoupons)
    },
  })

  return { coupons, setCoupons, listFpMemberCouponsLazyQuery, loadingListFpMemberCoupons }
}

export default useFpmemberCoupons
